import React from "react";
import { type FlexProps, Flex } from "@chakra-ui/react";

type ArticleContainerProps = Omit<FlexProps, "gap">;

export const articleContainerGap = 24;

export function ArticleContainer({ children, ...props }: ArticleContainerProps) {
  return (
    <Flex gap={articleContainerGap} width="100%" {...props}>
      {children}
    </Flex>
  );
}
